// extracted by mini-css-extract-plugin
export var arrow = "faq-module--arrow--094c0";
export var faqAnswer = "faq-module--faqAnswer--74e5a";
export var faqContainer = "faq-module--faqContainer--6f6c9";
export var faqItem = "faq-module--faqItem--d3351";
export var faqQuestion = "faq-module--faqQuestion--17568";